module.exports = __webpack_public_path__ + "img/senior-logo-5.b49655be.png";